import { getProductsStationDestinationSuggestions } from '@/api/generated/products-stations/products-stations';
import type { ListRequest, StationDestinationSuggestion } from '@/api/generated/schemas';
import {
  defineEntityAsyncSelector,
  listRequestQueryKey,
  selectorPresets,
  toListRequest,
  type NoPickFilters,
} from '@/shared/ui/async-selector';
import { createAsyncSelectorField } from '@/shared/forms';
import type { DestinationRef } from '../productsApi';

const destinationSelector = defineEntityAsyncSelector<
  DestinationRef,
  StationDestinationSuggestion,
  ListRequest,
  NoPickFilters
>({
  api: {
    fetch: getProductsStationDestinationSuggestions,
    buildApiParams: (ctx) => toListRequest(ctx.search, ctx.ids),
    queryKey: (request) => listRequestQueryKey('products.stations.destinations', request),
    mapItem: (s) => ({
      destinationId: s.destinationId,
      name: s.name ?? '',
      code: s.code ?? null,
    }),
  },
  key: (item) => item.destinationId,
  objectCategory: 'Destination',
  // Tři tečky (⋯) otevřou list page dané ObjectCategory v Magic desktopu, ne interní React pick modal.
  listPicker: 'legacy',
  display: {
    kind: 'nameCode',
    name: (item) => item.name,
    code: (item) => item.code,
  },
  columns: (t) =>
    selectorPresets.nameAndCode({
      name: {
        id: 'name',
        header: t('stationSelectors.destination.columns.name'),
        value: (item) => item.name,
        sortable: true,
      },
      code: {
        id: 'code',
        header: t('stationSelectors.destination.columns.code'),
        value: (item) => item.code,
        emptyDash: '—',
      },
    }),
  i18n: { namespace: 'products' },
});

export const DestinationSelector = destinationSelector.Selector;
export const DestinationSelectorField = createAsyncSelectorField(DestinationSelector);
